<div class="position-relative standard-code-autocomplete">
  <div class="input-group" [class.input-group-sm]="size === 'sm'">
    @if (selectedItem && !open) {
      <div class="form-control border-end-0 selected-display d-flex flex-column justify-content-center text-start"
           [class.form-control-sm]="size === 'sm'"
           [class.disabled]="disabled"
           [id]="id"
           (click)="onSelectedClick()"
           [attr.tabindex]="disabled ? -1 : 0"
           (keydown.enter)="onSelectedClick()"
           (keydown.space)="onSelectedClick()"
           role="combobox"
           [attr.aria-expanded]="open">
        <div class="d-flex align-items-baseline gap-2 flex-wrap">
          @if (formatCodeDisplay(selectedItem); as codeDisplay) {
            <span class="text-secondary fw-semibold">{{ codeDisplay }}</span>
          }
          <span class="text-dark standard-title">{{ selectedItem.title }}</span>
        </div>
        @if (selectedItem.titleEng) {
          <small class="text-muted ms-1">{{ selectedItem.titleEng }}</small>
        }
      </div>
    }

    <input #searchInput
           type="text"
           class="form-control border-end-0"
           [class.d-none]="selectedItem && !open"
           [class.form-control-sm]="size === 'sm'"
           [id]="selectedItem && !open ? id + '-input' : id"
           [attr.name]="name"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [value]="searchText"
           [(ngModel)]="searchText"
           [ngModelOptions]="standaloneOptions"
           (ngModelChange)="onInputChange()"
           (focus)="onFocus()"
           (blur)="handleBlur()"
           (keydown)="onKeyDown($event)"
           role="combobox"
           aria-autocomplete="list"
           [attr.aria-expanded]="open"
           [attr.aria-controls]="id + '-options'"
           autocomplete="off"/>
    <span class="input-group-text bg-white border-start-0 action-buttons" [class.disabled]="disabled">
      @if ((selectedItem || searchText) && !disabled) {
        <button
          type="button"
          class="btn-clear p-0 border-0 bg-transparent text-muted me-1"
          (mousedown)="clear($event)"
          title="ล้างข้อมูล"
          aria-label="ล้างข้อมูล">
          <i class="bi bi-x-lg"></i>
        </button>
      }
      <button
        type="button"
        class="btn-toggle p-0 border-0 bg-transparent"
        (mousedown)="toggleOpen($event)"
        [disabled]="disabled"
        tabindex="-1"
        aria-label="แสดงรายการมาตรฐาน">
        @if (loading) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
        } @else {
          <i class="bi bi-caret-down-fill" [class.rotated]="open"></i>
        }
      </button>
    </span>
  </div>

  @if (open) {
    <div class="dropdown-menu show w-100" [id]="id + '-options'" role="listbox" style="margin-top: 1px;">
      @if (loading) {
        <div class="dropdown-item text-muted disabled small d-flex align-items-center justify-content-center py-2">
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          <span>กำลังค้นหา...</span>
        </div>
      } @else if (suggestions.length === 0) {
        <div class="dropdown-item text-muted disabled small text-center py-2">
          ไม่พบข้อมูลมาตรฐาน
        </div>
      } @else {
        @for (item of suggestions; track item.id ?? $index; let i = $index) {
          <button
            type="button"
            class="dropdown-item d-flex align-items-center justify-content-between"
            [class.py-1]="size === 'sm'"
            role="option"
            [attr.aria-selected]="isSelected(item)"
            (mousedown)="selectStandard(item, $event)">
            <div class="d-flex flex-column text-start">
              <div class="d-flex align-items-baseline gap-2 flex-wrap">
                @if (formatCodeDisplay(item); as codeDisplay) {
                  <span class="text-secondary fw-semibold">{{ codeDisplay }}</span>
                }
                <span class="text-dark standard-title">{{ item.title }}</span>
              </div>
              @if (item.titleEng) {
                <small class="text-muted ms-1">{{ item.titleEng }}</small>
              }
            </div>
            @if (isSelected(item)) {
              <i class="bi bi-check2 text-primary ms-2 flex-shrink-0"></i>
            }
          </button>
        }
      }
    </div>
  }
</div>
